import { render } from "./manage_patient.vue?vue&type=template&id=7bf6968b"
import script from "./manage_Patient.js?vue&type=script&lang=js"
export * from "./manage_Patient.js?vue&type=script&lang=js"

import "./manage_patient.vue?vue&type=style&index=0&id=7bf6968b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__